var _module_exports ="<div ng-if=\"ctxItem\"\n     bcm-bia-profile\n     box-tmpl=\"nav\" box-tmpl-behavior=\"ctxt\"\n     box-model=\"ctxItem\"\n     box-click=\"goToContext()\">\n</div>\n";;
var path = '/app/Main/BCM/GOVHistoryCtxtDirective-biaProfileEdit.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;